import React, { useState } from 'react';
import Checkbox from '../../../../../../../components/Common/UI/Checkbox';
import { Button } from '../../../../../../../components/Common/UI/Button';
import { useMessageManagerProvider } from '../../../../../../context/messageManager';

function EmptyModel() {
  const { state, handleDispatch } = useMessageManagerProvider();

  const [showPrompt, setShowPrompt] = useState<boolean>(false);

  const handleStatement = (payload: boolean) => {
    handleDispatch({
      step2: {
        ...state.step2,
        statement: {
          ...state.step2.statement,
          statement: payload,
        },
      },
    });
  };

  return (
    <div className="text-center self-center justify-center">
      <div className="text-primary mb-[15px] text-xl font-bold">Select a tab to begin editing</div>
      {/* flex */}
      <div className="gap-2 items-center justify-center hidden">
        <Checkbox
          id="checkbox"
          checked={state.step2.statement.statement}
          onClick={() => {
            setShowPrompt(true);
            handleStatement(true);
          }}
        />
        <label
          htmlFor="checkbox"
          className="text-sm text-primary cursor-pointer
          font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          Add end of statement messaging
        </label>
      </div>
      {showPrompt ? (
        <div className="max-w-[400px] mx-auto">
          <div className="text-sm my-[20px] text-primary">
            End of Statement messaging will drive an additional page. would you like to continue?
          </div>
          <div className="flex gap-[20px] justify-center">
            <Button
              variant="ghost"
              className="text-destructive hover:text-destructive hover:opacity-70"
              onClick={() => handleStatement(false)}
            >
              Unselect
            </Button>
            <Button onClick={() => setShowPrompt(false)}>Continue</Button>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default EmptyModel;
